import type { ComponentStyleConfig } from "@chakra-ui/react";

export const linkStyle: ComponentStyleConfig = {
  baseStyle: {
    _hover: {
      color: "primary",
    },
  },
};
